/* VORL Animations & Interactivity */
(function () {
  'use strict';

  /* ===========================
     META PIXEL MANUAL - ELIMINADO EL 2026-09-22. NO VOLVER A ANADIRLO.

     Historia, para que nadie lo reponga:
     - 2026-07-01 se anadio aqui un disparo manual de InitiateCheckout en el clic de
       "Comprar" porque el checkout de Shopify no emitia ese evento por navegador.
       Era correcto entonces.
     - 2026-08-13/14: el evento mandaba 10 EUR cuando el PVP ya era 49 (venia de la
       epoca de reserva). Se arreglo leyendo el precio de Shopify en ejecucion.
     - 2026-09-22: el canal Facebook & Instagram de Shopify YA emite InitiateCheckout.
       Comprobado en Events Manager: el mismo clic generaba DOS eventos, uno por
       "configuracion manual" (este archivo) y otro por "integracion con socios".
       Con el evento duplicado Meta ve el doble de conversiones y el coste por
       InitiateCheckout aparenta la mitad del real.

     Por que se quita el manual y no el del canal:
     - el del canal se dispara en el checkout de verdad, no en el clic (que contaba
       tambien a quien pulsaba y nunca llegaba);
     - el del canal lleva event_id y Meta puede deduplicarlo contra la Conversions API.
       Un disparo manual no lleva event_id: no se puede deduplicar nunca.

     Si algun dia hace falta un evento que el canal no emita, se dispara a mano PERO
     comprobando antes en Events Manager que el canal no lo este mandando ya.
     Se van con el los ayudantes de precio y moneda, sin ningun otro uso en el archivo.
     =========================== */

  /* ===========================
     SCROLL FADE-IN (IntersectionObserver)
     =========================== */
  function initFadeAnimations() {
    var els = document.querySelectorAll('.vorl-fade-up');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ===========================
     PRODUCT CARD 3D TILT ON SCROLL
     =========================== */
  function initProductScroll() {
    var card = document.querySelector('.vorl-product__card');
    if (!card) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          card.classList.add('in-view');
        }
      });
    }, { threshold: 0.3 });

    observer.observe(card);
  }

  /* ===========================
     NAV SCROLL EFFECT
     =========================== */
  function initNavScroll() {
    var nav = document.querySelector('.vorl-nav');
    if (!nav) return;

    function onScroll() {
      if (window.scrollY > 40) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===========================
     MOBILE MENU
     =========================== */
  function initMobileMenu() {
    var btn = document.querySelector('.vorl-nav__hamburger');
    var menu = document.querySelector('.vorl-nav__mobile-menu');
    var iconOpen = document.querySelector('.vorl-nav__icon-open');
    var iconClose = document.querySelector('.vorl-nav__icon-close');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var isOpen = menu.classList.contains('open');
      menu.classList.toggle('open');
      if (iconOpen) iconOpen.style.display = isOpen ? 'block' : 'none';
      if (iconClose) iconClose.style.display = isOpen ? 'none' : 'block';
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('open');
        if (iconOpen) iconOpen.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }

  /* ===========================
     INGREDIENTS ACCORDION
     =========================== */
  function initAccordion() {
    var triggers = document.querySelectorAll('.vorl-accordion__trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.vorl-accordion__item');
        if (!item) return;
        item.classList.toggle('open');
        var expanded = item.classList.contains('open');
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  /* ===========================
     BUY NOW - Skip Cart, Go Directly to Checkout
     =========================== */
  function initBuyNow() {
    var btns = document.querySelectorAll('[data-buy-now]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var qtyInput = btn.closest('[data-buy-block]')
          ? btn.closest('[data-buy-block]').querySelector('[data-qty]')
          : null;
        var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        var originalHTML = btn.innerHTML;
        btn.textContent = 'Procesando...';
        btn.style.pointerEvents = 'none';

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
            });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            btn.innerHTML = originalHTML;
            btn.style.pointerEvents = '';
            window.location.href = '/cart/' + variantId + ':' + quantity;
          });
      });
    });
  }

  /* ===========================
     QUANTITY SELECTOR (+/-)
     =========================== */
  function initQtySelectors() {
    document.querySelectorAll('[data-qty-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('[data-buy-block]').querySelector('[data-qty]');
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    });
    document.querySelectorAll('[data-qty-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('[data-buy-block]').querySelector('[data-qty]');
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    });
  }

  /* ===========================
     SMOOTH SCROLL FOR ANCHOR LINKS
     =========================== */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    initFadeAnimations();
    initProductScroll();
    initNavScroll();
    initMobileMenu();
    initAccordion();
    initBuyNow();
    initQtySelectors();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
